import React from "react";

import { useTranslation } from "react-i18next";

import { useBibliotecaContext } from "../../context/BibliotecaContext";

export function NcmFilter() {
    const { t } = useTranslation();

    const { ncm, setNcm } = useBibliotecaContext();

    const handleChange = (event) => {
        setNcm(event.target.value);
    };

    return (
        <div className="mt-4 mb-3">
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <input
                    type="text"
                    name="ncm"
                    className="form-control rounded-lg"
                    placeholder={t("biblioteca.Ncm")}
                    value={ncm}
                    onChange={handleChange}
                    style={{
                        height: "40px",
                        flex: 1,
                    }}
                />
            </div>
        </div>
    );
}
